<script>
    import FaInfoCircle from 'svelte-icons/fa/FaInfoCircle.svelte'
    import FaCheckCircle from 'svelte-icons/fa/FaCheckCircle.svelte'
    import {slide} from 'svelte/transition'

    export let cl = ''
    export let animate = false
    let icon = FaInfoCircle
    if (cl.includes('success')) {
        icon = FaCheckCircle
    }
</script>
<style>
    .parent {
        background: var(--area);
        border: var(--gray) 1px solid;
        padding: 0.5rem;
        border-radius: 0.5rem;
    }

    .error {
        background: var(--red-area);
        border-color: var(--red);
        color: var(--red);
    }

    .success {
        background: var(--green-area);
        border-color: var(--green);
        color: var(--green);
    }
    .warning {
        background: #FFFFF0;
        border-color: #F6E05E;
        color: #975A16;
    }
    p {
        padding: 0;
        margin: 0;
    }
</style>

<div class="parent flex flex-auto items-center {cl}" transition:slide={{duration: animate? 400 : 0} }>
    <span class="icon mr1 self-start flex-none"><svelte:component this={icon}/></span>
    <p class='flex-auto'>
        <slot>Error</slot>
    </p>
</div>